import { render, staticRenderFns } from "./DashboardFreestallMeas.vue?vue&type=template&id=70977a2c&scoped=true&"
import script from "./DashboardFreestallMeas.vue?vue&type=script&lang=js&"
export * from "./DashboardFreestallMeas.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFreestallMeas.vue?vue&type=style&index=0&id=70977a2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70977a2c",
  null
  
)

export default component.exports